var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.id)?_c('b-btn',{attrs:{"id":_vm.id}},[_vm._t("default"),_c('b-popover',{attrs:{"target":_vm.id,"triggers":_vm.triggers,"custom-class":"p-2","placement":_vm.placement,"boundary":"window"}},[_vm._t("popover")],2)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }